module.exports = __webpack_public_path__ + "img/horizontal_4_4_7016.54ee4274.png";